import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as HolidayRSVPActions from 'web-app/react/profile/child-profile/holiday-rsvp/actions';
import * as LeaveRegistrationActions from 'web-app/react/profile/child-profile/leave-registration/actions';
import {replayOnTriggerObservable} from 'web-app/util/epics-helpers';

import {PERSON_TYPE} from './constants';
import * as Actions from './actions';
import * as Api from './api';

const fetch = action$ =>
    action$.ofType(Actions.fetch.type).mergeMap(({payload}) => {
        let apiObservable;
        if (payload.personType === PERSON_TYPE.EMPLOYEE) {
            apiObservable = Api.fetchEmployeeLeaveSummary(payload.personId).map(leaveSummary =>
                Actions.fetchSuccess.action(leaveSummary.leaveSummary, leaveSummary.bradfordFactor),
            );
        } else {
            apiObservable = Observable.zip(
                Api.fetchLeaveSummary(payload.personId),
                Api.fetchVacations(payload.personId),
            ).map(([leaveSummary, {vacations, timezone}]) =>
                Actions.fetchSuccess.action(leaveSummary.leaveSummary, null, vacations, timezone),
            );
        }
        return apiObservable.catch(e => Observable.of(Actions.fetchFailed.action(e)));
    });

const listenForUpdates = action$ => {
    const replayObservable = action$.ofType(Actions.fetch.type);
    const resetObservable = action$.ofType(Actions.reset.type);

    const triggerReplayObservable = action$.ofType(LeaveRegistrationActions.updateSuccess.type);

    const predicate = (replayAction, updateAction) => replayAction.payload.personId === updateAction.payload.personId;

    return replayOnTriggerObservable(replayObservable, resetObservable, triggerReplayObservable, predicate).catch(
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => {},
    );
};

export const deleteChildCalendarLeaveObservable = (childId, leaveId, startDate, endDate) =>
    Api.deleteLeaveDay(leaveId).flatMap(() => [
        Actions.deleteChildLeaveSuccess.action(startDate, endDate),
        Actions.fetch.action(childId),
    ]);

const deleteChildLeave = action$ =>
    action$.ofType(Actions.deleteChildLeave.type).mergeMap(({payload}) =>
        Api.deleteLeavePeriodObservable(payload.childId, payload.startDate, payload.endDate)
            .flatMap(() => [
                Actions.deleteChildLeaveSuccess.action(payload.startDate, payload.endDate),
                Actions.fetch.action(payload.childId, PERSON_TYPE.CHILD),
            ])
            .catch(() => Observable.of(Actions.deleteChildLeaveFailed.action(payload.startDate))),
    );

const refetchAndCloseModal = action$ =>
    action$.ofType(HolidayRSVPActions.updateSuccess.type).map(({payload}) => Actions.fetch.action(payload.childIds[0]));

export default combineEpics(fetch, listenForUpdates, deleteChildLeave, refetchAndCloseModal);
